import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { getShippingFees } from './services/firebaseService';

const Footer = () => {
  const { t } = useTranslation();
  const [showShippingModal, setShowShippingModal] = useState(false);
  const [shippingFeesLoading, setShippingFeesLoading] = useState(false);
  const [shippingFeesConfig, setShippingFeesConfig] = useState({
    westMalaysia: { firstKg: 10, additionalKg: 3 },
    eastMalaysia: { firstKg: 10, additionalKg: 12 }
  });

  const openShippingPolicyModal = async () => {
    setShippingFeesLoading(true);
    const result = await getShippingFees();
    if (result.success) {
      setShippingFeesConfig(result.shippingFees);
    }
    setShippingFeesLoading(false);
    setShowShippingModal(true);
  };

  return (
    <footer className=" w-full border-t-4 border-blue-300 bg-primary py-12 text-white shadow-none">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 md:grid-cols-4 md:px-8">
        <div className="col-span-1 md:col-span-2 flex flex-col justify-between gap-8">
          <div>
            
            <p className="mb-3 text font-medium text-blue-100">
              {t('footer.companyRegistration')}
            </p>
            
            <div className="mt-4 space-y-1 text-sm text-blue-100/95">
              <p>{t('contact.address')}</p>
              <p>
                {t('footer.phone')}:{' '}
                <a href="tel:+6052533729" className="transition-colors hover:text-white hover:underline underline-offset-4">
                  {t('contact.phone')}
                </a>
              </p>
              <p>
                {t('footer.email')}:{' '}
                <a href="mailto:industriesmmk@gmail.com" className="transition-colors hover:text-white hover:underline underline-offset-4">
                  {t('contact.email')}
                </a>
              </p>
            </div>
          </div>
          <p className="text-xs text-blue-100/80">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
        </div>

        <div className="col-span-1">
          <h4 className="mb-4 text-xs font-bold uppercase tracking-widest text-blue-100">{t('footer.quickLinks')}</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/check-order-status" className="text-blue-100/90 transition-colors hover:text-white hover:underline underline-offset-4 decoration-2">
                {t('subHeader.checkOrderStatus')}
              </Link>
            </li>
          </ul>
        </div>

        <div className="col-span-1">
          <h4 className="mb-4 text-xs font-bold uppercase tracking-widest text-blue-100">{t('footer.legalPolicies')}</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <a
                href="/assets/docs/mmk_tnc.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-100/90 transition-colors hover:text-white hover:underline underline-offset-4 decoration-2"
              >
                {t('footer.termsAndConditions')}
              </a>
            </li>
            <li>
              <a
                href="/assets/docs/mmk_privacy.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-100/90 transition-colors hover:text-white hover:underline underline-offset-4 decoration-2"
              >
                {t('footer.privacyPolicy')}
              </a>
            </li>
            <li>
              <a
                href="/assets/docs/mmk_warranty.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-100/90 transition-colors hover:text-white hover:underline underline-offset-4 decoration-2"
              >
                {t('footer.warrantyPolicy')}
              </a>
            </li>
            <li>
              <button
                type="button"
                onClick={openShippingPolicyModal}
                className="text-blue-100/90 transition-colors hover:text-white hover:underline underline-offset-4 decoration-2"
              >
                {t('subHeader.shippingPolicy')}
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* <div className="mx-auto mt-10 max-w-7xl px-4 md:px-8">
        <div className="flex flex-wrap gap-4 text-xs text-blue-100/80">
          <a
            href="/assets/docs/mmk_tnc.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-white hover:underline underline-offset-4"
          >
            {t('footer.termsAndConditions')}
          </a>
          <a
            href="/assets/docs/mmk_privacy.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-white hover:underline underline-offset-4"
          >
            {t('footer.privacyPolicy')}
          </a>
          <a
            href="/assets/docs/mmk_warranty.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-white hover:underline underline-offset-4"
          >
            {t('footer.warrantyPolicy')}
          </a>
        </div>
      </div> */}
      {showShippingModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={() => setShowShippingModal(false)}>
          <div className="bg-white rounded-2xl p-4 md:p-8 max-w-4xl w-full mx-4 shadow-2xl max-h-[90vh] overflow-y-auto text-gray-800" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-primary">{t('shipping.title')}</h2>
              <button
                onClick={() => setShowShippingModal(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors"
                aria-label={t('common.close')}
              >
                <CloseIcon className="!w-6 !h-6" />
              </button>
            </div>

            <div className="space-y-6">
              {shippingFeesLoading && (
                <p className="text-gray-500 text-sm">{t('shipping.refreshing')}</p>
              )}
              <div>
                <h3 className="text-lg font-semibold text-primary mb-3">{t('shipping.westMalaysia')}</h3>
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <h4 className="text-md font-semibold text-blue-800 mb-2">{t('shipping.standardDelivery')}</h4>
                  <p className="text-blue-700 text-sm">
                    {t('shipping.firstKg', { amount: Number(shippingFeesConfig.westMalaysia.firstKg).toFixed(2) })}
                  </p>
                  <p className="text-blue-700 text-sm">
                    {t('shipping.additionalKg', { amount: Number(shippingFeesConfig.westMalaysia.additionalKg).toFixed(2) })}
                  </p>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-primary mb-3">{t('shipping.eastMalaysia')}</h3>
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <h4 className="text-md font-semibold text-blue-800 mb-2">{t('shipping.standardDelivery')}</h4>
                  <p className="text-blue-700 text-sm">
                    {t('shipping.firstKg', { amount: Number(shippingFeesConfig.eastMalaysia.firstKg).toFixed(2) })}
                  </p>
                  <p className="text-blue-700 text-sm">
                    {t('shipping.additionalKg', { amount: Number(shippingFeesConfig.eastMalaysia.additionalKg).toFixed(2) })}
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-6 text-center">
              <button
                onClick={() => setShowShippingModal(false)}
                className="bg-primary text-white px-6 py-2 rounded-lg hover:bg-blue-900 transition-colors font-semibold"
              >
                {t('shipping.close')}
              </button>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
